import cookie from 'js-cookie';

export default { set: cookie.set, get: cookie.get };



// WEBPACK FOOTER //
// ./src/lib/cookie.js